import classes from './index.module.scss';

export interface MyTableFooterProps {
  className?: ClassNames;
  children?: ReactNode;
}

export default function MyTableFooter({ className, children }: MyTableFooterProps) {
  if (!children) return null;
  return <div className={cls(classes.myTableFooter, className)}>{children}</div>;
}
